import LazyCodeEditor from "../../components-legacy/LazyCodeEditor.jsx"
import BuyCreditsMessage from "../../components-legacy/BuyCreditsMessage.jsx"

export default function StrategyCode({ strId, error, code, state = null, setCodeState, strategyType }) {

    if (error) {
        if (error === 'INSUFFICIENT_CREDITS') {
            return <BuyCreditsMessage />
        } else {
            return <div className="code-error py-2 px-4 rounded-md border border-danger-dim bg-danger-dim text-danger text-body">Error processing code</div>
        }
    }

    if (state === null) {
        return
    }

    return (
        <div className="strategy-ai-chat-code rounded-md overflow-hidden border border-border bg-card relative">
            {error && (
                <div className="code-error py-2 px-4 rounded-md border border-danger-dim bg-danger-dim text-danger text-body">{error}</div>
            )}

            <div className="content show relative h-[70vh] min-h-[480px]">
                <LazyCodeEditor code={code} readOnly={true} language={strategyType === 2 ? 'python' : 'mql5'} />
            </div>
        </div>
    )
}
